let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cMkgU")).then(() => parcelRequire('gP2jG'));